import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../ReusableComponents/Button/Button';
import styles from '../Deliveries.module.css';
import DeliveryDetails from '../DeliveryDetails';
import LocationSelector from '../LocationSelector';

function ConfirmDeliveryDetails(props) {
  const {
    saveDelivery,
    setLocation = null,
    locations,
    delivery,
    onClose,
    back,
    loading,
  } = props;

  return (
    <div className={styles.step}>
      <div className={styles.stepContainer}>
        <h3 className={styles.confirmHeader}>Confirm Delivery Details: </h3>

        {setLocation && (
          <div
            className={styles.confirmLocationContainer}
            data-testid="confirm-location-container"
          >
            <div className={styles.confirmLocationHeader}>
              Confirm Location:
            </div>

            <LocationSelector
              selectedLocation={locations[delivery.location_id]}
              onChange={(id) => setLocation(locations[id])}
              locations={locations}
            />
          </div>
        )}

        <DeliveryDetails locations={locations} delivery={delivery} />

        <div className={styles.stepActions}>
          <Button
            onClick={back}
            disabled={loading}
            color="primary"
            variant="outlined"
            className={styles.backButton}
          >
            Back
          </Button>
          <Button
            onClick={onClose}
            variant="text"
            className={styles.cancelButton}
            color="primary"
          >
            Cancel
          </Button>
          <Button
            onClick={saveDelivery}
            disabled={loading}
            variant="contained"
            color="white"
            className={styles.nextButton}
          >
            {loading ? 'Saving' : 'Submit'}
          </Button>
        </div>
      </div>
    </div>
  );
}

ConfirmDeliveryDetails.propTypes = {
  back: PropTypes.func.isRequired,
  delivery: PropTypes.shape({}).isRequired,
  loading: PropTypes.bool.isRequired,
  locations: PropTypes.shape({}).isRequired,
  onClose: PropTypes.func.isRequired,
  saveDelivery: PropTypes.func.isRequired,
  setLocation: PropTypes.func,
};

export default ConfirmDeliveryDetails;
